import { render, staticRenderFns } from "./NotificationsBanner.vue?vue&type=template&id=1969df82"
import script from "./NotificationsBanner.vue?vue&type=script&lang=js"
export * from "./NotificationsBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports